import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { GET_TASK_DASHBOARD_STATS } from './actionTypes';
import { getTaskDashboardStatsSuccess, getTaskDashboardStatsError } from './actions';

// Include call API
import { getTasksAPI } from '../../../api/tasks';

const tasksAPI = getTasksAPI();

function* getTaskDashboardStats({ payload: { user } }) {
  try {
    const response = yield call(tasksAPI.getDashboardStats, user.token);
    yield put(getTaskDashboardStatsSuccess(response.stats, response.message));
  } catch (error) {
    yield put(getTaskDashboardStatsError(error));
  }
}

export function* watchGetTaskDashboardStats() {
  yield takeEvery(GET_TASK_DASHBOARD_STATS, getTaskDashboardStats);
}

function* getTaskDashboardStatsSaga() {
  yield all([fork(watchGetTaskDashboardStats)]);
}

export default getTaskDashboardStatsSaga;
